import React, { createContext, useContext, useEffect, useState } from 'react';

const GPUContext = createContext({
  hasGPUAcceleration: true,
  setGPUAcceleration: () => {},
});

export const GPUProvider = ({ children }) => {
  const [hasGPUAcceleration, setHasGPUAcceleration] = useState(false);

  useEffect(() => {
    const detectGPUAcceleration = () => {
      let gpuCapable = true;

      try {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (!gl) {
          console.warn('WebGL not supported');
          return false;
        }

        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        const renderer = debugInfo
          ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
          : '';

        const isSoftware = renderer.toLowerCase().includes('swiftshader') ||
          renderer.toLowerCase().includes('llvmpipe') ||
          renderer.toLowerCase().includes('software') ||
          renderer.toLowerCase().includes('basic render');

        if (isSoftware) {
          console.warn(`Software renderer detected: ${renderer}`);
          gpuCapable = false;
        }

        const supports3D = CSS.supports('transform', 'translateZ(0)');
        if (!supports3D) {
          console.warn('CSS 3D transforms not supported');
          gpuCapable = false;
        }

        const cores = navigator.hardwareConcurrency || 0;
        if (cores < 2) {
          console.warn('Low hardware concurrency:', cores);
          gpuCapable = false;
        }

        return gpuCapable;
      } catch (err) {
        console.error('GPU detection failed:', err);
        return false;
      }
    };

    const result = detectGPUAcceleration();
    setHasGPUAcceleration(result);
  }, []);

  return (
    <GPUContext.Provider value={{ hasGPUAcceleration, setGPUAcceleration: setHasGPUAcceleration }}>
      {children}
    </GPUContext.Provider>
  );
};

export const useGPU = () => useContext(GPUContext);
